// @ts-nocheck
/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Identity Api
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { GetApiV1UserParams } from '../model/getApiV1UserParams';

import type { IdentityApplicationFeaturesUsersGetUserProfileUserProfileDto } from '../model/identityApplicationFeaturesUsersGetUserProfileUserProfileDto';

import type { IdentityApplicationFeaturesUsersUserDto } from '../model/identityApplicationFeaturesUsersUserDto';

import type { IdentityWebModelsUserUserClaimDto } from '../model/identityWebModelsUserUserClaimDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Autorisatie.GebruikersInzien</li></ul>
 * @summary Returns the list of all (internal) users present in Identity
 */
export const getApiV1User = (
  params?: MaybeRef<GetApiV1UserParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<IdentityApplicationFeaturesUsersUserDto[]>(
    { url: `/api/v1/user`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetApiV1UserQueryKey = (params?: MaybeRef<GetApiV1UserParams>) =>
  ['api', 'v1', 'user', ...(params ? [params] : [])] as const;

export const getGetApiV1UserQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV1User>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<GetApiV1UserParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1User>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetApiV1UserQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1User>>> = ({ signal }) =>
    getApiV1User(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV1User>>,
    TError,
    TData
  >;
};

export type GetApiV1UserQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1User>>>;
export type GetApiV1UserQueryError = ErrorType<null | null>;

/**
 * @summary Returns the list of all (internal) users present in Identity
 */

export function useGetApiV1User<
  TData = Awaited<ReturnType<typeof getApiV1User>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<GetApiV1UserParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1User>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV1UserQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Autorisatie.GebruikersInzien</li></ul>
 * @summary Returns a single Identity user
 */
export const getApiV1UserUserId = (
  userId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  userId = unref(userId);

  return customInstance<IdentityApplicationFeaturesUsersUserDto>(
    { url: `/api/v1/user/${userId}`, method: 'GET', signal },
    options,
  );
};

export const getGetApiV1UserUserIdQueryKey = (userId?: MaybeRef<string | undefined | null>) =>
  ['api', 'v1', 'user', userId] as const;

export const getGetApiV1UserUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV1UserUserId>>,
  TError = ErrorType<null | null | null>,
>(
  userId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserId>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetApiV1UserUserIdQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UserUserId>>> = ({ signal }) =>
    getApiV1UserUserId(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(userId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserId>>, TError, TData>;
};

export type GetApiV1UserUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV1UserUserId>>
>;
export type GetApiV1UserUserIdQueryError = ErrorType<null | null | null>;

/**
 * @summary Returns a single Identity user
 */

export function useGetApiV1UserUserId<
  TData = Awaited<ReturnType<typeof getApiV1UserUserId>>,
  TError = ErrorType<null | null | null>,
>(
  userId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserId>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV1UserUserIdQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Deletes a identity user and marks the SUREnet user as removed.
 */
export const deleteApiV1UserUserId = (
  userId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
) => {
  userId = unref(userId);

  return customInstance<null>({ url: `/api/v1/user/${userId}`, method: 'DELETE' }, options);
};

export const getDeleteApiV1UserUserIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiV1UserUserId>>,
    TError,
    { userId: string | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiV1UserUserId>>,
  TError,
  { userId: string | undefined | null },
  TContext
> => {
  const mutationKey = ['deleteApiV1UserUserId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiV1UserUserId>>,
    { userId: string | undefined | null }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteApiV1UserUserId(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiV1UserUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiV1UserUserId>>
>;

export type DeleteApiV1UserUserIdMutationError = ErrorType<unknown>;

/**
 * @summary Deletes a identity user and marks the SUREnet user as removed.
 */
export const useDeleteApiV1UserUserId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiV1UserUserId>>,
      TError,
      { userId: string | undefined | null },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteApiV1UserUserId>>,
  TError,
  { userId: string | undefined | null },
  TContext
> => {
  const mutationOptions = getDeleteApiV1UserUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiV1UserProfile = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) =>
  customInstance<IdentityApplicationFeaturesUsersGetUserProfileUserProfileDto>(
    { url: `/api/v1/user/profile`, method: 'GET', signal },
    options,
  );

export const getGetApiV1UserProfileQueryKey = () => ['api', 'v1', 'user', 'profile'] as const;

export const getGetApiV1UserProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV1UserProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserProfile>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetApiV1UserProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UserProfile>>> = ({ signal }) =>
    getApiV1UserProfile(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV1UserProfile>>,
    TError,
    TData
  >;
};

export type GetApiV1UserProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV1UserProfile>>
>;
export type GetApiV1UserProfileQueryError = ErrorType<unknown>;

export function useGetApiV1UserProfile<
  TData = Awaited<ReturnType<typeof getApiV1UserProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV1UserProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export const getApiV1UserClaims = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) =>
  customInstance<IdentityWebModelsUserUserClaimDto[]>(
    { url: `/api/v1/user/claims`, method: 'GET', signal },
    options,
  );

export const getGetApiV1UserClaimsQueryKey = () => ['api', 'v1', 'user', 'claims'] as const;

export const getGetApiV1UserClaimsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV1UserClaims>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserClaims>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetApiV1UserClaimsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UserClaims>>> = ({ signal }) =>
    getApiV1UserClaims(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV1UserClaims>>,
    TError,
    TData
  >;
};

export type GetApiV1UserClaimsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV1UserClaims>>
>;
export type GetApiV1UserClaimsQueryError = ErrorType<unknown>;

export function useGetApiV1UserClaims<
  TData = Awaited<ReturnType<typeof getApiV1UserClaims>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserClaims>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV1UserClaimsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
